import React, { useState } from 'react'
import { createRoot } from 'react-dom/client'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

void (() => {
  const AnchorsNavigation = ({ anchors, ...props }) => {
    const navigationElements = anchors.map(anchor => {
      return {
        location: anchor.dataset.anchor,
        label: anchor.dataset.anchorLabel
      }
    })

    const goToSection = (event, section) => {
      window.scrollTo({
        top: document.querySelector(`#${section}`).offsetTop - 56,
        behavior: 'smooth'
      })
      event.preventDefault()
    }

    const [isVisible, setIsVisible] = useState(false)

    const handleClick = () => {
      setIsVisible(!isVisible)
    }

    if (props.templateType === 'HLP') {
      return (
        <div className='[ f-c-ba-whi f-radius-card-large f-shadow-strong f-p-a-020 ]'>
          <span className='[ f-d-bl f-t-tbody ]'>Inhalt</span>
          <ol className='[ f-!list ]'>
            {navigationElements.map(element => {
              return (
                <li className='[ f-d-flr f-m-a-0 f-p-t-020 ]'>
                  <Icon
                    icon='right-arrow-16px'
                    className='[ f-fl-no f-icon-010 f-c-st-pri f-m-r-020 ] AnchorsNavigation-caret'
                  />
                  <CTA
                    type='text-primary'
                    tag='a'
                    href={`#${element.location}`}
                    className='[ f-fl-expand f-p-r-020 ]'
                    onClick={event => goToSection(event, element.location)}
                    data-text={element.label}>
                    {element.label}
                  </CTA>
                </li>
              )
            })}
          </ol>
        </div>
      )
    }
    return (
      <div className='[ f-wrap f-d-flr f-fl-wrap ] AnchorsNavigation-wrapper'>
        <button
          onClick={handleClick}
          className={`[ f-hidden:m f-hidden:l f-c-fo-pri f-t-tbody ] AnchorsNavigation-mobile-button ${
            isVisible ? 'is-visible' : ''
          }`}>
          Inhaltsverzeichnis
          <Icon
            icon='down-arrow-16px'
            className='[ f-icon-030 f-c-st-pri ] AnchorsNavigation-caret'></Icon>
        </button>
        <div
          className={`[ f-d-flr f-fl-wrap ] AnchorsNavigation-items f-focus-outline-secondary ${
            isVisible ? 'is-visible' : ''
          }`}>
          <span className='[ f-hidden:s f-p-a-010 f-c-fo-pri f-t-tbody ] AnchorsNavigation-title'>
            Themen:
          </span>
          {navigationElements.map(element => {
            return (
              <a
                key={element.location}
                href={`#${element.location}`}
                onClick={event => goToSection(event, element.location)}
                className='[ f-d-inbl f-t-tbody f-c-fo-ter f-p-a-010 ] AnchorsNavigation-item'
                data-text={element.label}>
                {element.label}
              </a>
            )
          })}
        </div>
      </div>
    )
  }

  const anchorsWrappers = document.querySelectorAll(
    '.js-anchors-navigation-wrapper'
  )

  for (const anchorsWrapper of anchorsWrappers) {
    const templateType = anchorsWrapper.dataset.template
    const anchorsBlockClassName = anchorsWrapper.dataset.anchorsBlockClassName
    const anchors = [...document.querySelectorAll('[data-anchor]')]

    if (anchors.length && anchorsWrapper) {
      for (const anchor of anchors) {
        anchor.closest(anchorsBlockClassName).id = anchor.dataset.anchor
      }
      const root = createRoot(anchorsWrapper)
      root.render(
        <AnchorsNavigation
          anchors={anchors}
          wrapper={anchorsWrapper}
          templateType={templateType}
        />
      )
    }
  }
})()
